import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
  theme: {
    primary: '#27AE60',
    secondary: '#2f4351',
    accent: '#666',
    error: '#f44336',
    warning: '#ffeb3b',
    info: '#2196f3',
    success: '#00ac81'
  }
})
